import { render, staticRenderFns } from "./ProductMutation.vue?vue&type=template&id=6644d89f&scoped=true&"
import script from "./ProductMutation.vue?vue&type=script&lang=js&"
export * from "./ProductMutation.vue?vue&type=script&lang=js&"
import style0 from "./ProductMutation.vue?vue&type=style&index=0&id=6644d89f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6644d89f",
  null
  
)

export default component.exports